import React from 'react';
import PropTypes from 'prop-types';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const KpiCard = ({ icon, value, label, trend, trendPositive, onClick, subValue }) => {
    return (
        <div 
            onClick={onClick}
            style={{
                background: 'var(--ant-color-bg-container, #ffffff)',
                border: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
                borderRadius: 12,
                padding: '20px 24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: 120,
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03)',
                cursor: onClick ? 'pointer' : 'default',
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 20, display: 'flex', alignItems: 'center' }}>
                    {icon}
                </div>
                {trend && (
                    <div style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: trendPositive ? '#10b981' : '#ef4444',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2
                    }}>
                        {trendPositive ? <ArrowUpOutlined style={{ fontSize: 10 }} /> : <ArrowDownOutlined style={{ fontSize: 10 }} />}
                        {trend}
                    </div>
                )}
            </div>
            <div style={{ marginTop: 12 }}>
                <div style={{
                    fontSize: 28,
                    fontWeight: 700,
                    color: 'var(--ant-color-text, #111827)',
                    fontFamily: 'var(--font-family-geist)',
                    lineHeight: '36px'
                }}>
                    {value}
                </div>
                {subValue && (
                    <div style={{
                        fontSize: 12,
                        color: 'var(--ant-color-text-secondary, #9ca3af)',
                        fontWeight: 500,
                        marginTop: 2
                    }}>
                        {subValue}
                    </div>
                )}
                <div style={{
                    fontSize: 14,
                    color: 'var(--ant-color-text-secondary, #6b7280)',
                    fontWeight: 500,
                    marginTop: 4
                }}>
                    {label}
                </div>
            </div>
        </div>
    );
};

KpiCard.propTypes = {
    icon: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
    label: PropTypes.string.isRequired,
    trend: PropTypes.string,
    trendPositive: PropTypes.bool,
    subValue: PropTypes.node,
};

KpiCard.defaultProps = {
    trend: null,
    trendPositive: true,
    subValue: null,
};

export default KpiCard;
